//import { ApiClientBase } from '../../../common/api-client/api-client-base';
import { GraclMetadata } from '../products/portal/modules/gracl/api/change-requests';
import { ApiClientBase } from '@@/api/api';
import { ApiResult } from '@@/types/ApiResult';
import { InstanceData } from '@@/types/InstanceData';

export interface baseApiRequest {
  instanceId: string;
  region: string;
}
export interface BaseApiQueryString {
  instanceId: string;
  region: string;
}

interface BaseApiInput {
  $metadata?: GraclMetadata;
}

export interface RequestBase<T, H = object> {
  input: T & BaseApiInput;
  queryString: H & BaseApiQueryString;
}

export interface baseApiResponse {
  message: string;
}

export interface getRolesPermissionsResponse {
  globalPermissions: string[];
  instances: Record<string, InstanceData>;
}

export interface getUserPoolConfigResponse {
  userPoolId: string;
  clientId: string;
  companyId: string;
}

export class CommonClient extends ApiClientBase {
  async getRolePermissions(): Promise<ApiResult<getRolesPermissionsResponse | undefined>> {
    try {
      const headers = await this.getHeaders();
      const result = await fetch(this.getCommonApiUrl(`/common/get-my-permissions?instanceId=global`), {
        headers
      });

      if (!result.ok) {
        return this.error('Failed to get role permissions');
      }

      return result.json();
    } catch (error) {
      return this.error('Failed to get role permissions');
    }
  }

  async fetchUserPoolConfig(email: string): Promise<ApiResult<getUserPoolConfigResponse>> {
    try {
      const headers = await this.getHeaders();
      const url = this.getCommonApiUrl(`/public/user-pool/${email}`);
      const result = await fetch(url, {
        method: 'GET',
        headers: headers
      });

      if (!result.ok) {
        try {
          const body = await result.json();
          return this.error(body.data.error);
        } catch {
          // In case the API Gateway or Lambda function fails to return a
          // proper JSON error response, we return a generic error.
          return this.error('Sorry, an internal error has occurred.');
        }
      }

      return result.json();
    } catch (error) {
      console.error(error);
      return this.error('Cannot fetch User Pool configuration.');
    }
  }
}
